/// <amd-module name="Wit/Settings/BoardsExternalIntegration/components/panels/addRepoManually/AddRepoManuallyPanel.Props" />
import { ExternalConnection } from "Wit/Clients/Internal/Contracts/WorkItemTracking";
import { IBasePanelContentProps } from "Wit/Settings/BoardsExternalIntegration/components/panels/BasePanelContent.Props";

export interface IAddRepoManuallyPanelProps extends IBasePanelContentProps {
    /**
     * Current connection
     */
    connection: ExternalConnection;

    /**
     * Type of repository.
     */
    repositoryType: string;

    /**
     * Callback to navigate back to AddRepo Panel
     */
    onBackClick: () => void;

    /**
     * Callback to save the connection
     */
    onSave: (connection: ExternalConnection) => Promise<ExternalConnection>;
}
